module.exports = __webpack_public_path__ + "img/V23.e17c870b.png";